<div *ngIf="events.length > 0">
    <div class="row m-2 list-events" *ngFor="let event of events">
        <div *ngIf="source === 'dashboard' && filterApplied" class="row w-100 mb-2">
            <div class="col-2 d-flex align-items-center">
                <i title="{{event.eventTypeText}}" *ngIf="event.eventType" [className]="event.eventTypeIcon"
                    style="opacity: .6"></i>
            </div>
            <div class="col-10 p-0 m-0" *ngIf="source === 'dashboard' && filterApplied">
                <span>{{event.eventTypeText}}</span>&nbsp;<span class="text-lowercase">{{'FOR' | translate}}</span><a
                    [routerLink]="['/patient', event.memberId]" [queryParams]="{breadcrumb: 'ALL'}">
                    {{event.memberName}}
                </a><span class="text-lowercase">{{'TO' |
                    translate}}</span>&nbsp;<span *ngIf="event.facility">{{event.facility}}</span>
                <span
                    *ngIf="event.appointment && event.appointment.provider">{{event.appointment.provider}}</span>&nbsp;<span
                    class="text-lowercase" *ngIf="event.details">{{ (event.referral ? 'FROM' : 'FOR') |
                    translate}}&nbsp;<span>{{event.details}}</span></span>
                <span *ngIf="event.referral" class="text-lowercase">&nbsp;{{'REFERRED' | translate}}&nbsp;</span><span
                    *ngIf="event.referral?.from" class="text-lowercase">{{'FROM' | translate}}&nbsp;</span><span
                    style="color: rgba(0, 0, 0, 0.5);"
                    *ngIf="event.referral?.from">{{event.referral.from.name?.fullName}}&nbsp;</span><span
                    *ngIf="event.referral?.to" class="text-lowercase">{{'TO' | translate}}&nbsp;</span><span
                    style="color: rgba(0, 0, 0, 0.5);"
                    *ngIf="event.referral?.to">{{event.referral.to.name?.fullName}}&nbsp;</span><span
                    *ngIf="event.referral?.reason" class="text-lowercase">{{'FOR' |
                    translate}}&nbsp;{{event.referral.reason}}.</span><span
                    *ngIf="event.appointment && event.appointment.status === 'CANCELLED'">&nbsp;({{'APPOINTMENT-STATUS-CANCELLED'
                    | translate}})</span>
                <br />
                <span class="event-date-time">{{event.eventDateTime | date:'MMMM d, y, h:mm:ss a'}}</span>
            </div>
        </div>
        <div class="col-12 p-0" *ngIf="source === 'patientSummary' && filterApplied">
            <span class="event-date-time">{{event.eventDateTime | date:'MMMM d, y, h:mm:ss a'}}</span>
            <br />
            <span class="font-weight-bold"
                *ngIf="event.details && event.eventType !== 'APPOINTMENT'">{{event.details}}&nbsp;</span><span
                class="text-lowercase" *ngIf="event.facility">{{(event.referral ? 'BY' :'FROM') |
                translate}}&nbsp;</span><span *ngIf="event.facility">{{event.facility}}</span>
            <span *ngIf="event.eventType === 'APPOINTMENT'">
                <span *ngIf="event.facility"><br /></span>
                <span *ngIf="event.eventType === 'APPOINTMENT'">{{'EVENT-TYPE-APPOINTMENT' | translate
                    }}&nbsp;{{getAppointmentStatusText(event.appointment.status)}}&nbsp;</span>
                <span class="font-weight-bold">{{event?.appointment?.title}}</span>
            </span>
            <span *ngIf="event.referral" class="text-lowercase">&nbsp;{{'REFERRED' | translate}}&nbsp;</span><span
                *ngIf="event.referral?.from" class="text-lowercase">{{'FROM' | translate}}&nbsp;</span><span
                *ngIf="event.referral?.from">{{event.referral.from.name?.fullName}}&nbsp;</span><span
                *ngIf="event.referral?.to" class="text-lowercase">{{'TO' | translate}}&nbsp;</span><span
                *ngIf="event.referral?.to">{{event.referral.to.name?.fullName}}&nbsp;</span><span class="text-lowercase"
                *ngIf="event.referral?.reason">{{'FOR' | translate}}&nbsp;{{event.referral.reason}}.</span>
        </div>
    </div>
</div>
<div *ngIf="events.length === 0">
    <div class="row" style="color: rgba(0, 0, 0, 0.6);">
        <div class="col-12" *ngIf="filterApplied">
            <span>{{'NO-EVENTS' | translate}}</span>
        </div>
    </div>
</div>